var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbsUpDown = function SvgThumbsUpDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.43236,5.99972h-2.846a5.0479,5.0479,0,0,0,.89445-2.62488c0-1.301-.32525-2.27681-1.46364-2.52075C9.96012.61015,9.55356.93541,9.30962,1.66723c-.32526.81315-.32526,1.78894-.65051,2.35813a6.66492,6.66492,0,0,1-2.283,2.70755C5.93844,7.00629,5,7.045,5,8.13279v6.4008a.75415.75415,0,0,0,.56919.70416,10.54407,10.54407,0,0,1,2.846.65953,5.51132,5.51132,0,0,0,2.68335.48789c1.44887,0,2.68334-.16263,3.33385-.81315a2.42935,2.42935,0,0,0,.48788-1.87023,1.93049,1.93049,0,0,0,.5692-2.11417,2.34529,2.34529,0,0,0,.32525-2.19549A1.98124,1.98124,0,0,0,14.43236,5.99972Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.57547,24h2.846a4.80817,4.80817,0,0,0-.89445,2.55289c0,1.301.32525,2.27681,1.46364,2.52076,1.05708.24394,1.46364-.08132,1.70759-.81315.32525-.81315.32525-1.78894.65051-2.35812a6.66485,6.66485,0,0,1,2.283-2.70756C26.06939,22.92145,27,22.88344,27,21.79567V15.39414a.74705.74705,0,0,0-.56136-.70415,10.5449,10.5449,0,0,1-2.846-.65953,5.51109,5.51109,0,0,0-2.68335-.48789c-1.44886,0-2.68334.16263-3.33385.81314a2.42939,2.42939,0,0,0-.48788,1.87023,1.93049,1.93049,0,0,0-.5692,2.11417,2.34536,2.34536,0,0,0-.32525,2.1955A2.03179,2.03179,0,0,0,17.57547,24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1,7v9H4V7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31,24.00035v-9H28v9Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUpDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbsUpDown.5d18498e.svg";
export { ForwardRef as ReactComponent };